// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2Ep8D","header":"style_header__1tK_G","content":"style_content__1n57L","footer":"style_footer__3VZ3y"};